import {View} from 'native-base';
import React from 'react';

import {OfferFiltersProperty} from 'models/OfferFilters';

import OfferFilterList from '../List';

export interface OfferPropertiesListProps {
  properties: OfferFiltersProperty[];
  selected: OfferFiltersProperty[];
  onSelect: (item: OfferFiltersProperty) => void;
  onSelectAll: () => void;
  availableProperties?: string[];
  propertiesOfferCount: {[key: string]: number};
}

const OfferPropertiesList: React.FC<OfferPropertiesListProps> = props => {
  const {
    properties,
    selected,
    onSelect,
    onSelectAll,
    availableProperties,
    propertiesOfferCount,
  } = props;
  const handleSelect = item => () => {
    onSelect && onSelect(item);
  };

  const isSelected = (item: OfferFiltersProperty) =>
    selected ? selected.indexOf(item) !== -1 : false;

  return (
    <View flex={1}>
      <OfferFilterList
        isPropertyList
        list={properties}
        onSelect={properties.length > 1 ? handleSelect : undefined}
        isSelected={isSelected}
        hasAllOption={true}
        onSelectAll={onSelectAll}
        allSelected={
          properties.length === selected?.length || selected?.length === 0
        }
        offersCount={propertiesOfferCount}
        setBottomBorder={true}
        isModal={true}
        availableProperties={availableProperties}
      />
    </View>
  );
};

export default OfferPropertiesList;
